
/* injects from baggage-loader */

const buttonActionsModule = angular.module('buttonActions.setting', []);

buttonActionsModule.directive("buttonActions", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "blockEditDialog", "Widget",
  ($window, $timeout, $compile, $templateCache, ns, blockEditDialog, Widget) => {
    return {
      restrict: "A",
      scope: {
        widget: "=ngModel",
        afterChange: '&',
        buttonProperty: '&'
      },
      templateUrl: settingFolder + "/buttonActions/template.jade",
      link: function(scope, element, attrs, ngModel) {
        scope.button_property = attrs.buttonProperty;
        scope.form_property = attrs.formProperty;
        scope.Editor = angular.copy(window.Editor);
        scope.showModalForm = function(id) {
          if ($(".vex").length > 0) {
            vex.closeAll();
          } else {
            vex.open({
              content: "",
              appendLocation: "[data-block-id='" + scope.widget.id + "']",
              contentClassName: 'vex-form__modal',
              afterOpen: function($vexContent) {
                log(id);
                $vexContent.append($("[data-block-id=" + id + "]"));
                $('.link_view-form').addClass("link_view-form_active");
              },
              afterClose: function(s) {
                $("[data-block-id='" + scope.widget.id + "']").find(ns.widgetWrapperClass).eq(0).append(s.find('.strw-form__hidden'));
                $('.link_view-form').removeClass("link_view-form_active");
              }
            });
          }
          $(".vex").css({
            zIndex: 344
          });
        };
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/buttonActions/buttonActions.directive.js